module.exports = __webpack_public_path__ + "img/fast_eller_rorligt.e38faaf5.jpg";